import React, {useState, useEffect} from 'react'
import queryString from "qs"
import {Pagination} from "antd"
import BatchesFilters from "./filters/BatchesFilters"
import BatchesTable from "./table/BatchesTable"
import {Link} from "react-router-dom"
import {listErrorConfirmed} from "../../../services/api/3dApi"
import { getListBrand } from '../../../services/api/3dApi'

function BatchReproductionPage(props) {
    const [filters, setFilters] = useState({})
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [batches, setBatches] = useState([])
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [limit, setLimit] = useState(50)
    const [selectedBatchId, setSelectedBatchId] = useState([])
    const [selectedAll, setSelectedAll] = useState(false)
    const [listBrand, setListBrand] = useState([])

    async function getBatchesError() {
        try {
            setLoading(true)
            setError('')

            let params = {...filters, page, limit}
            if(!!filters && !!filters.tags && filters.tags.some(i => i === 'FBA')){
                params.tags = [...filters.tags, 'fba']
            }else{
                params.tags = filters.tags
            }

            const query = queryString.stringify(params)

            const {data: response} = await listErrorConfirmed(query)

            const {success, data, message} = response

            if (!success) {
                setLoading(false)
                return setError(message)
            }

            setSelectedAll(false)
            setSelectedBatchId([])
            setLoading(false)
            setBatches(data.batches)
            setTotal(data.total)

        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    function _handleChangeInput(field, value) {
        setFilters({
            ...filters,
            [field]: value
        })
        setPage(1)
    }

    function _handleShowSizeChange(current, size) {
        setLimit(size)
        setPage(1)
    }

    function _handleChangeProductType(value) {
        setFilters({
            ...filters,
            product_types: value
        })
        setPage(1)
    }

    function _handleChangeDate(filtersValue) {
        setFilters(filtersValue)
        setPage(1)
    }

    function _handlePageChange(page) {
        setPage(page)
    }

    function _toggleSelectAll(isChecked) {
        if (isChecked) {
            const batchId = batches.map(batch => batch._id)

            setSelectedBatchId(batchId)
            setSelectedAll(true)
        } else {
            setSelectedBatchId([])
            setSelectedAll(false)
        }
    }

    function _updateSelectedBatches(id, isAdded) {
        if (isAdded && !selectedBatchId.includes(id)) {
            setSelectedBatchId([...selectedBatchId, id])
            setSelectedAll(selectedBatchId.length + 1 === batches.length)
        } else {
            const filtered = selectedBatchId.filter(batch => batch !== id)

            setSelectedBatchId(filtered)
            setSelectedAll(false)
        }
    }

    const _getListBrand = async() => {
        const payload = {
            limit:10000,
            page:1
        }
        try {
            const {data:Data}= await getListBrand(payload)
            const {data, success, message}= Data
            const Brands= data.Brands.map(i=>({value:i.name, label:i.name}))
            if(success){
                setListBrand(Brands)
            }else{
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getBatchesError()
        // eslint-disable-next-line
    }, [page, limit, filters])

    useEffect(() => {
        _getListBrand()
    }, [])

    return (
        <div className='BatchReproductionPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className="mt-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className='m-0'>Danh sách lô có items lỗi QC sau ép </h3>
                            <Link to="/batches" className="ant-btn ant-btn-default">Quay về danh sách lô</Link>
                        </div>

                        <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                            <BatchesFilters
                                loading={loading}
                                filters={filters}
                                listBrand={listBrand}
                                onChangeInput={_handleChangeInput}
                                onChangeDate={_handleChangeDate}
                                onChangeProductType={_handleChangeProductType}
                            />
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                            <div>
                                {error && (
                                    <div className="text-danger mb-2">{error}</div>
                                )}
                            </div>
                            <Pagination
                                current={page}
                                total={total}
                                pageSize={limit}
                                showTotal={(sum, range) => sum > 0 &&
                                    <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                    </div>}
                                onChange={_handlePageChange}
                                className='text-right' showSizeChanger
                                pageSizeOptions={['10', '20', '50', '100']}
                                onShowSizeChange={_handleShowSizeChange}/>
                        </div>
                        <div className="BatchesTableContainer">
                            <BatchesTable
                                status={filters.status}
                                batches={batches}
                                loading={loading}
                                selectedAll={selectedAll}
                                selectedBatchId={selectedBatchId}
                                getBatchesError={getBatchesError}
                                onChangeProductType={_handleChangeProductType}
                                onSelectAll={_toggleSelectAll}
                                onUpdateSelectedBatches={_updateSelectedBatches}
                                handleChangeInput={_handleChangeInput}
                            />
                        </div>
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            showQuickJumper
                            className='text-right'
                            showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onChange={_handlePageChange}
                            onShowSizeChange={_handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BatchReproductionPage
